import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 状态
    INTERVIEW_STATUS: computed(() => store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_STATUS),
    // 弹窗类型
    FREQUENCY_CONFIG_POPUP_TYPE: computed(() => store.state.label.data.WEBSITE.FREQUENCY_CONFIG_POPUP_TYPE),
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
